import { ChecklistSeal } from "../models/checklist.seal";
import BaseService from "./_base.service";
import API from "../api";
import { AxiosResponse } from "axios";

const endpoint = "checklist/seals";

const ChecklistSealsService = {
  ...BaseService<ChecklistSeal>({ endpoint }),

  async baseCreate(body?: any): Promise<AxiosResponse<ChecklistSeal>> {
    return await API.post(`/${endpoint}/checked`, body);
  },

  async getByRelation(params?: any): Promise<AxiosResponse<ChecklistSeal[]>> {
    return await API.get(`/${endpoint}`, { params: params });
  },
};

export default ChecklistSealsService;
